import React from 'react'
import { Autocomplete, TextField } from '@mui/material'

import { LocationSuggestion } from 'types/LocationData'

interface LocationAutocompleteProps {
  suggestions: LocationSuggestion[]
  selectedLocation: LocationSuggestion
  onInputChange: (
    event: React.SyntheticEvent<Element, Event>,
    newInputValue: string,
  ) => void
  onSelectionChange: (
    event: React.SyntheticEvent<Element, Event>,
    value: string | LocationSuggestion | null,
  ) => void
  readOnlyMode: boolean
}

const LocationAutocomplete: React.FC<LocationAutocompleteProps> = ({
  suggestions,
  selectedLocation,
  onInputChange,
  onSelectionChange,
  readOnlyMode,
}) => {
  return (
    <Autocomplete
      freeSolo
      options={suggestions}
      getOptionLabel={(option: any) => option.label}
      value={selectedLocation}
      onChange={onSelectionChange}
      disableClearable={readOnlyMode}
      renderInput={(params) => (
        <TextField
          {...params}
          value={selectedLocation?.label || ''}
          onChange={(e) => onInputChange(e, e.target.value)}
          variant="standard"
          inputProps={{ ...params.inputProps, readOnly: readOnlyMode }}
        />
      )}
    />
  )
}

export default LocationAutocomplete
